import { FC } from 'react';
import { useTranslation, useSession } from '@nextgen-web-framework/all';
import { formatNumber } from '@nextgen-web-framework/core';
import type { PVBVComponentPropsTypes } from './types/propsTypes';
import styles from './PVBVComponent.module.scss';
import { PVBVType } from './types/enums';

const PVBVComponent: FC<PVBVComponentPropsTypes> = ({
  pointValue = '',
  businessVolume = '',
  pvbvType,
}: PVBVComponentPropsTypes): JSX.Element => {
  const t = useTranslation();
  const disableBVCondition = ConfigService.getConfigs()?.NEXT_BUSINESS_VOLUME_DISABLE_FLAG || false;
  const PVBVClassName = () => {
    switch (pvbvType) {
      case PVBVType.PVBVCART:
        return 'pvbv-cart-container';
      case PVBVType.PVBVCARTMOBILE:
        return 'pvbv-cart-container-mobile-force';
      case PVBVType.PVBVCHECKOUT:
        return 'pvbv-checkout-container';
      case PVBVType.PVBVPDP:
        return 'pvbv-pdp-container';
      case PVBVType.PVBVPRODUCTMERCHANDISE:
        return 'pvbv-merchandise-container';
      case PVBVType.PVBVSEARCHCARD:
        return 'pvbv-searchcard-container';
      case PVBVType.PVBVABOCHECKBOXCARD:
        return 'pvbv-aboCheckbox-container';
      case PVBVType.PVBV_FREE_CART_CARD:
        return 'pvbv-free-cart-card';
      default:
        return 'cpw-pv-bv-container';
    }
  };

  const { isABO } = useSession();

  const convertToNumberAndFormat = (strValue: string) => {
    const numValue = Number(strValue);
    if (isNaN(numValue)) {
      // Range is coming for values e.g. '12-45'
      const [start, end] = strValue.split('-').map((value) => formatNumber(Number(value)));
      return `${start}-${end}`;
    } else {
      return formatNumber(numValue);
    }
  };

  const pvBv: string[] = [];
  if (pointValue) {
    pvBv.push(`${t('product.PV.label')} ${convertToNumberAndFormat(pointValue)}`);
  }
  if (businessVolume && !disableBVCondition) {
    pvBv.push(`${t('product.BV.label')} ${convertToNumberAndFormat(businessVolume)}`);
  }

  return (
    <>
      {isABO() && pvBv.length > 0 && (
        <div className={`${styles[PVBVClassName()]}`} data-testid={`${PVBVClassName()}`}>
          {pvBv.join(' / ')}
        </div>
      )}
    </>
  );
};

export default PVBVComponent;
export type { PVBVComponentPropsTypes };
export { PVBVType };
